module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/configuration/configuration.component.css
// module id = ./src/app/configuration/configuration.component.css
// module chunks = main